import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10ZM6.8227 12.6727C6.5591 12.9363 6.5591 13.3637 6.8227 13.6273C7.08631 13.8909 7.51369 13.8909 7.7773 13.6273L10 11.4046L12.2227 13.6273C12.4863 13.8909 12.9137 13.8909 13.1773 13.6273C13.4409 13.3637 13.4409 12.9363 13.1773 12.6727L10.4773 9.9727C10.2137 9.7091 9.78631 9.7091 9.5227 9.9727L6.8227 12.6727ZM6.8227 10.0273C6.5591 9.76369 6.5591 9.33631 6.8227 9.0727L9.5227 6.3727C9.78631 6.1091 10.2137 6.1091 10.4773 6.3727L13.1773 9.0727C13.4409 9.33631 13.4409 9.76369 13.1773 10.0273C12.9137 10.2909 12.4863 10.2909 12.2227 10.0273L10 7.80459L7.7773 10.0273C7.51369 10.2909 7.08631 10.2909 6.8227 10.0273Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }